import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ItemshistoryPage } from './itemshistory';

@NgModule({
  declarations: [
    ItemshistoryPage,
  ],
  imports: [
    IonicPageModule.forChild(ItemshistoryPage),
  ],
})
export class ItemshistoryPageModule {}



// WEBPACK FOOTER //
// ./src/pages/itemshistory/itemshistory.module.ts